<div class="container">
  <h1>Thanks for your Pre-Registration!</h1>

  <p role="alert" class="step">
    @if (meeting) {
      Thank you! We look forward to seeing you on
      <b>{{ meeting.StartDateTime | date }}</b> at {{ ' ' }}
      <b>{{ meeting.StartDateTime | convertFrom24To12Format }}</b>
      . You will receive an email with more information before the event.
      <div class="checkmark-container" aria-hidden="true">
        <mat-icon class="checkmark">check_circle</mat-icon>
      </div>
    }
  </p>
</div>
